import arrayHelper from "../../../utils/array/array.helper";
import OrderOptimizerListRequest, {
  OrderOptimizerListRequestStatus,
} from "../../../api/raily/order-optimizer/list/order-optimizer-list.request";
import paginationService from "../../../utils/pagination/pagination.service";
import OrderOptimizerListParams, {
  OrderOptimizerListParamsStatus,
} from "./order-optimizer-list-params";

const createStatus = (
  status: OrderOptimizerListParamsStatus | undefined,
): OrderOptimizerListRequestStatus | undefined => {
  switch (status) {
    case OrderOptimizerListParamsStatus.INTERESTING:
      return OrderOptimizerListRequestStatus.INTERESTING;
    case OrderOptimizerListParamsStatus.PENDING:
      return OrderOptimizerListRequestStatus.PENDING;
    case OrderOptimizerListParamsStatus.REJECTED:
      return OrderOptimizerListRequestStatus.REJECTED;
    default:
      return undefined;
  }
};

const create = (
  params: OrderOptimizerListParams,
): OrderOptimizerListRequest => {
  const offset =
    params.page && params.pageSize
      ? paginationService.calculateOffset(params.page, params.pageSize)
      : undefined;

  return {
    limit: params.pageSize,
    offset: offset,
    orderHumanId: params.orderHumanId,
    maximumDelay: params.maximumDelay,
    maximumHaltingTime: params.maximumHaltingTime,
    mergePlanEntries: params.mergePlanEntries,
    ignoreCargo: arrayHelper.getNonEmpty(params.ignoreCargo),
    ignoreOnlyWithCargo: arrayHelper.getNonEmpty(params.ignoreOnlyWithCargo),
    ignoreOnlyWithTaxi: arrayHelper.getNonEmpty(params.ignoreOnlyWithTaxi),
    ignoreTaxi: arrayHelper.getNonEmpty(params.ignoreTaxi),
    excludeStatus: createStatus(params.excludeStatus),
    status: createStatus(params.status),
  };
};

const orderOptimizerListParamsFactory = { create };

export default orderOptimizerListParamsFactory;
